"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class AssetRemoveDataRequest extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'assetRemoveDataRequest';
        this._assetId = initParams.asset_id;
        this._start = initParams.start;
        this._end = initParams.end;
        this._status = initParams.status;
    }
    set assetId(value) {
        console.error('Do not set objects this way');
    }
    get assetId() {
        return this._assetId;
    }
    set start(value) {
        console.error('Do not set objects this way');
    }
    get start() {
        return this._start;
    }
    set end(value) {
        console.error('Do not set objects this way');
    }
    get end() {
        return this._end;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    get status() {
        return this._status;
    }
}
exports.default = AssetRemoveDataRequest;
//# sourceMappingURL=assetRemoveDataRequest.js.map